import PropTypes from 'prop-types';
import { fetchPermissionToken } from '../services/auth.service';
import { setAccessToken } from '@vindr/utils/auth';

function CallbackPage({ userManager, onRedirectSuccess }) {
  const onRedirectError = error => {
    throw new Error(error);
  };

  const authUrl = userManager.settings.authority + '/protocol/openid-connect/token';

  userManager
    .signinRedirectCallback()
    .then((user) => {
      // Save token to not redirect next time
      setAccessToken(user.access_token, user.expires_at - new Date().getTime() / 1000);
      fetchPermissionToken(user.access_token, authUrl).then(res => {
        onRedirectSuccess({ ...user, permission_token: res?.access_token });
      });
    })
    .catch((error) => onRedirectError(error));

  return null;
}

CallbackPage.propTypes = {
  userManager: PropTypes.object.isRequired,
};

export default CallbackPage;
